module.exports = __webpack_public_path__ + "static/img/term_library_modify_single_delete.c368e71f.gif";